import * as fromHistory from "history"
import { routerMiddleware } from "react-router-redux"
import { Middleware } from "../../node_modules/redux"

export const history: fromHistory.History = fromHistory.createBrowserHistory()

export const router: Middleware = routerMiddleware(history)

export const isSameLocation = (pathName: string, location: string) =>
  pathName.includes(location, pathName.length - location.length)
